export const name = 'wixEventsWixCodeSdk' as const
export const namespace = 'wixEvents' as const
